"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverBody = void 0;

var _colors = require("./colors");

var popoverBody = {
  colors: {
    default: {
      color: _colors.colors.gray900
    }
  },
  padding: {
    default: '0.5rem 0.75rem'
  }
};
exports.popoverBody = popoverBody;